import { getAmplitudeInstance } from '../amplitudeHelpers';

/**
 * User dismisses the checkout modal screen
 */
const logCheckoutScreenDismissed = (callback?: () => void) => {
  getAmplitudeInstance().logEvent('checkout screen dismissed', {}, callback);
};

export default logCheckoutScreenDismissed;
